import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../';
import { basketDataSlice, BasketDataState } from '../../../redux';
import {
  StripeClientSecretData,
  useStripeClientSecretEffect,
} from '../../../../server';

export interface BasketSecretGetDataEffectReturn {
  enact: (cartId: number) => void;
  clear: () => void;
  loading: boolean;
  success: boolean | undefined;
  error?: string;
}

export const useBasketSecretGetEffect = (): BasketSecretGetDataEffectReturn => {
  const dispatch = useDispatch();

  const { basketDataState } = useSelector((state: StoreState) => ({
    basketDataState: state.data.basket,
  }));

  const [success, setSuccess] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const stripeClientSecret = useStripeClientSecretEffect({
    onComplete: (response: StripeClientSecretData) => {
      const secret = basketDataState.secret
        ? basketDataState.secret
        : response.data.data.paymentIntent.client_secret;

      const updatedBasketDataState: BasketDataState = Object.assign({}, {
        ...basketDataState,
        secret,
      } as BasketDataState);

      stripeClientSecret.clear();
      dispatch(basketDataSlice.actions.update(updatedBasketDataState));
      setSuccess(true);
      setLoading(false);
    },
    onError: (error: string) => {
      stripeClientSecret.clear();
      setErrorMessage(error);
      setSuccess(false);
      setLoading(false);
    },
  });

  const basketSecretGet = (cartId: number) => {
    setLoading(true);
    stripeClientSecret.enact(cartId);
  };

  const clear = () => {
    setErrorMessage(undefined);
    setSuccess(undefined);
    setLoading(false);
  };

  return {
    enact: basketSecretGet,
    clear,
    loading,
    success,
    error: errorMessage,
  };
};
